import { render, staticRenderFns } from "./CmgCreateAccountForm.vue?vue&type=template&id=0187a0a3&scoped=true&lang=pug"
import script from "./cmg-create-account-form.ts?vue&type=script&lang=ts&external"
export * from "./cmg-create-account-form.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCreateAccountForm.vue?vue&type=style&index=0&id=0187a0a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187a0a3",
  null
  
)

export default component.exports